import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const ClinicSolution = () => {
  return (
    <section id="clinic-solution" className="landing clinic-landing">
      <Helmet>
        <title>Clinic Management Software for Polyclinics India — Mediway Nextgen</title>
        <meta name="description" content="The best clinic management software for polyclinics, single doctors, and clinic networks in India. Manage appointments, prescriptions, and billing." />
        <link rel="canonical" href="https://mediwaynextgen.wayug.com/solutions/for-clinics-and-polyclinics" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            'name': 'Clinic Management Software',
            'description': 'Tailored clinic and polyclinic management platform with EHR, automated billing, and patient SMS portals.',
            'brand': 'Mediway Nextgen',
            'url': 'https://mediwaynextgen.wayug.com/solutions/for-clinics-and-polyclinics',
            'applicationCategory': 'MedicalApplication'
          })}
        </script>
      </Helmet>

      <div className="container">
        <header className="section-header">
          <h2 className="section-title">HMS Software for Clinics &amp; Polyclinics</h2>
          <p className="section-subtitle">Affordable, lightweight, and powerful clinic management system to digitize patient appointments, prescriptions, and accounting.</p>
        </header>

        <div className="service-content">
          <div className="service-header">
            <div className="service-icon">🩺</div>
            <div className="service-info">
              <h3 className="service-title">Optimized for Fast Care</h3>
              <p className="service-description">Reduce patient wait times with lightning-fast digital prescriptions, WhatsApp integration, and one-click billing built for busy practitioners.</p>
            </div>
          </div>

          <div className="service-body">
            <div className="service-features">
              <h4>Core Clinic Features</h4>
              <ul className="features-list">
                <li className="feature-item"><span className="feature-check">✓</span><span>1-Minute Digital Prescriptions (EHR)</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>WhatsApp &amp; SMS appointment reminders</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Multi-doctor scheduling &amp; shift manager</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Daily collection summary &amp; accounting</span></li>
              </ul>
            </div>

            <div className="service-benefits">
              <h4>Polyclinic Benefits</h4>
              <div className="benefits-grid">
                <div className="benefit-card"><div className="benefit-icon">📱</div><span>Access from any tablet</span></div>
                <div className="benefit-card"><div className="benefit-icon">📉</div><span>No setup fees</span></div>
                <div className="benefit-card"><div className="benefit-icon">🤝</div><span>Patients trust reviews</span></div>
              </div>
            </div>
          </div>

          <div className="service-actions">
            <Link to="/contact" className="btn btn-primary">Start Free Clinic Demo</Link>
            <Link to="/pricing" className="btn btn-secondary">View Clinic Pricing</Link>
          </div>
        </div>
      </div>

      <div className="services-background">
        <div className="background-pattern"></div>
      </div>
    </section>
  );
};

export default ClinicSolution;
